// 设备管理api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'DeviceList/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'DeviceList/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'DeviceList/save',
        method: 'post',
        data
    })
}

export const workTimeStatsApi = (data) => {
    return request({
        url: 'DeviceList/workTimeStats',
        method: 'post',
        data
    })
}

export const workTimeStatsOperatorsApi = (data) => {
    return request({
        url: 'DeviceList/workTimeStatsOperators',
        method: 'post',
        data
    })
}

export const workTimeStatsDeviceApi = (data) => {
    return request({
        url: 'DeviceList/workTimeStatsDevice',
        method: 'post',
        data
    })
}

export const workTimeStatsTrendApi = (data) => {
    return request({
        url: 'DeviceList/workTimeStatsTrend',
        method: 'post',
        data
    })
}

export const utilizationCompareApi = (data) => {
    return request({
        url: 'DeviceList/utilizationCompare',
        method: 'post',
        data
    })
}

export const workSiteOptionsApi = (data) => {
    return request({
        url: 'DeviceList/workSiteOptions',
        method: 'post',
        data
    })
}